import { Helmet } from 'react-helmet-async';

import SingleCardTemplate from '@/components/layouts/SingleCardTemplate';
import { pageTitles } from '@/constants/pageTitles';
import WithdrawalForm from '@/features/withdrawal/components/WithdrawalForm';
import useModal from '@/hooks/common/useModal';

const WithdrawalPage: React.FC = () => {
  const { showModal } = useModal();

  const onClick = () => showModal('WithdrawalConfirmationModal', {});

  return (
    <SingleCardTemplate title={pageTitles.withdrawal}>
      <Helmet>
        <title>{pageTitles.withdrawal}</title>
      </Helmet>
      <WithdrawalForm onClick={onClick} />
    </SingleCardTemplate>
  );
};

export default WithdrawalPage;
